"use client";
import { styled } from "@mui/material/styles";
import { FontSize2, FontWeightBold, FontWeightDefault } from "@nxt-costco-com/forge-design-tokens";
const GasPriceContainer = styled("dd")`
    grid-row: 1;
    margin: 0;

    :nth-of-type(1) {
        grid-column: 1;
    }

    :nth-of-type(2) {
        grid-column: 2;
    }
`;
const GasDollarsAndCents = styled("span")`
    font-size: ${FontSize2};
    font-weight: ${FontWeightBold};
    line-height: 24px;
    letter-spacing: 0px;
    margin: 0;
`;
const GasFractionDigit = styled("sup")`
    font-size: 8px;
    font-weight: ${FontWeightBold};
    line-height: 16px;
    margin-left: 1px;
    padding-top: 2px;
    position: relative;
    top: 0.2em;
`;
const GasUnitDescription = styled("dt")`
    font-size: 12px;
    font-weight: ${FontWeightDefault};
    letter-spacing: 0%;
    line-height: 16px;
    horizontal-alignment: center;
    grid-row: 2;

    :nth-of-type(1) {
        grid-column: 1;
    }

    :nth-of-type(2) {
        grid-column: 2;
    }
`;
export {
  GasDollarsAndCents,
  GasFractionDigit,
  GasPriceContainer,
  GasUnitDescription
};
